export default __webpack_public_path__ + "static/media/kubwa-terminal.61f530de.png";